<div class="plot-band-feature">
  <mat-checkbox [checked]="plotBandFeature.visible" (click)="onPlotBandItemClick()">
    {{ series.name }}
  </mat-checkbox>
  <div class="legend-features-wrapper">
    <div
      *ngFor="let label of featureLabels; index as index"
      class="legend-feature"
      [class.faded-out]="!plotBandFeature.visible"
    >
      <span
        class="legend-feature-indicator"
        [style.background-color]="feautreLabelColors[index]"
      ></span>
      <div class="legend-feature-description">
        {{ label | translate }}
      </div>
    </div>
  </div>
</div>
